<template>
  <textarea
    :class="clsx('text-area', { 'text-area__disable' : isDisabled })"
    :placeholder="placeholder"
    :value="value"
    :disabled="isDisabled"
    :maxlength="limit"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
import { clsx } from 'clsx';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  methods: {
    clsx,
  }
};
</script>

<style lang="scss" scoped>
.text-area {
  background-color: #ffffff;
  border: 1px solid #E4E4E7;
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  color: #09090B;
  padding: 8px 12px;
  width: 100%;
  height: 100%;
  margin-bottom: 16px;

  &::placeholder {
    color: #D4D4D8;
  }

  &__disable {
    background-color: #F6F6F9;
  }
}
</style>
